<div class="container-button gap-8" [ngClass]="{'disabled': isDisabled}">
    <img src="./../../../../../assets/images/orden-venta/{{image}}.svg" alt="image-order">
    <span>{{text}}</span>
</div>